<template>
  <div class="page-container">
    TODO: Hier Idee mit der täglichen Checkliste aus Audibook
    "The Motivation Myth" umsetzten. Zu jedem Goal kann ein Daily Checklist
    definiert werden.
  </div>
</template>

<script>
export default {
  name: 'DailyChecklistPage',
  data() {
    return {
    };
  },
  mounted() {
    // this.toggleNavbarVisivility(true)
  },
  beforeDestroy() {
    // this.toggleNavbarVisivility(false)
  },
  methods: {
    toggleNavbarVisivility(hide) {
      let element = document.querySelector("#app > nav");
      element.style.display = hide ? 'none' : '';
    }
  },
  components: {
  }
};
</script>

<style scoped>
.page-container {
  background-color: white;
  margin: 0;
  width: 100%;
  height: 100vh;
}
</style>
